export var MessageConversationType;
(function (MessageConversationType) {
    MessageConversationType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    MessageConversationType["DIRECT"] = "DIRECT";
})(MessageConversationType || (MessageConversationType = {}));
export var MessagePriority;
(function (MessagePriority) {
    MessagePriority["NORMAL"] = "NORMAL";
    MessagePriority["HIGH"] = "HIGH";
    MessagePriority["URGENT"] = "URGENT";
})(MessagePriority || (MessagePriority = {}));
export var MessageConversationStatus;
(function (MessageConversationStatus) {
    MessageConversationStatus["DRAFT"] = "DRAFT";
    MessageConversationStatus["PUBLISHED"] = "PUBLISHED";
})(MessageConversationStatus || (MessageConversationStatus = {}));
//# sourceMappingURL=message.js.map